export default __webpack_public_path__ + "static/media/DEPARIS_03.4b48659d.gif";